module.exports = __webpack_public_path__ + "img/logo_bibi_bwana.3c56bec5.png";